import React, { useState } from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { PROGRAMS } from '../mock';
import { useLanguage } from '../i18n/LanguageContext';

const Programs = () => {
  const { t } = useLanguage();
  const [openSet, setOpenSet] = useState(new Set());

  const toggle = (key) => {
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  return (
    <section id="programs" className="jbss-programs">
      <div className="jbss-container">
        <div className="jbss-programs-head">
          <div>
            <span className="jbss-eyebrow">{t('programs.eyebrow')}</span>
            <h2 className="jbss-section-title">{t('programs.title')}</h2>
            <p className="jbss-section-sub">{t('programs.subtitle')}</p>
          </div>
          <button className="jbss-btn jbss-btn-outline">
            <span>{t('common.viewAll')}</span>
            <ArrowRight size={16} />
          </button>
        </div>

        <div className="jbss-program-grid jbss-program-grid-compact">
          {PROGRAMS.map((p) => {
            const Icon = p.icon;
            const isOpen = openSet.has(p.key);
            const title = t(`programs.items.${p.key}.title`);
            return (
              <article
                className={`jbss-program-card jbss-program-card-compact ${isOpen ? 'is-open' : ''}`}
                key={p.key}
              >
                <button
                  type="button"
                  className="jbss-program-toggle"
                  onClick={() => toggle(p.key)}
                  aria-expanded={isOpen}
                >
                  <span className="jbss-program-icon"><Icon size={18} /></span>
                  <span className="jbss-program-title">{title}</span>
                  <span className="jbss-program-chevron"><ChevronDown size={16} /></span>
                </button>
                <div className="jbss-program-collapse">
                  <div className="jbss-program-collapse-inner">
                    <div className="jbss-program-image">
                      <img src={p.image} alt={title} loading="lazy" />
                    </div>
                    <p className="jbss-program-desc">{t(`programs.items.${p.key}.desc`)}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Programs;
